import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'
import { isEmpty } from 'lodash'

import Footer from '../../components/Footer'
import { Icons } from '../../components/Icons'
import iconArrowBack from '../../assets/icons/arrowBack.svg'
import iconNext from '../../assets/icons/next.svg'

export default function ProfilePurchasesContainer(props) {
  const {
    navigate,
    oneTimePurchases = [],
  } = props

  return (
    <main className='appWrap'>
      <Button
        variant='contained'
        className='medium goBack'
        onClick={() => navigate('/cuenta')}
        startIcon={<Icons path={iconArrowBack} />}
      >
        Volver
      </Button>
      <div className='mainWidthProfile noHeroWrap'>
        <section className='planSection'>
          <header className='mediumHeader' style={{ marginBottom: '-10px' }}>
            <h3>Contenido comprado</h3>
          </header>
        </section>
        <section className='planSection'>
          {isEmpty(oneTimePurchases)
            ? (
              <div className='profileTextRow' style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '10px' }}>
                <p>Aún no tienes contenido comprado.</p>
                <br />
                <Link to='/planes'>Comprar contenido <Icons path={iconNext} /></Link>
              </div>
            )
            : (
              <div className='purchasesColsDisplay'>
                {oneTimePurchases.map(purchase => (
                  <div className='purchaseCard' key={purchase.id}>
                    <p><strong>{purchase.Plan?.shortName}</strong></p>
                    {purchase.Plan?.descripcion && <p>{purchase.Plan.descripcion}</p>}
                  </div>
                ))}
              </div>
            )
          }
        </section>
      </div>
      <Footer />
    </main>
  )
}
